import copperIcon from '../assets/copper.png';
import nickelIcon from '../assets/nickel.png';
import bronzeIcon from '../assets/bronze.png';
import silverIcon from '../assets/silver.png';
import goldIcon from '../assets/gold.png';
import platinumIcon from '../assets/platinum.png';
import noteIcon from '../assets/note.png';
import tradingCardIcon from '../assets/trading-card.png';

// Tier colors
const TIER_COLORS = {
  copper: '#B87333',
  nickel: '#B0ACA8',
  bronze: '#CD7F32',
  silver: '#C0C0C0',
  gold: '#FFD700',
  platinum: '#E5E4E2',
};

// Tier icon mapping
const TIER_ICONS = {
  copper: copperIcon,
  nickel: nickelIcon,
  bronze: bronzeIcon,
  silver: silverIcon,
  gold: goldIcon,
  platinum: platinumIcon,
};

/**
 * Get custom marker icon for different note types
 * @param {string} noteType - Type of note (static, collectible, business)
 * @param {string} noteTier - Optional tier for collectible notes (copper, nickel, bronze, silver, gold, platinum)
 * @returns {Object} - Google Maps marker icon configuration
 */
export function getNoteIcon(noteType, noteTier = null) {
  const baseIconConfig = {
    scaledSize: new window.google.maps.Size(40, 40),
    anchor: new window.google.maps.Point(20, 40),
  };

  // Use tiered coin icons for collectible notes with a tier
  if (noteType === 'collectible' && noteTier && TIER_ICONS[noteTier]) {
    return {
      ...baseIconConfig,
      url: TIER_ICONS[noteTier],
    };
  }

  // Use trading card icon for business notes AND common collectibles (collectible without tier)
  if (noteType === 'business' || noteType === 'collectible') {
    return {
      ...baseIconConfig,
      url: tradingCardIcon,
    };
  }

  // Use note icon for static notes
  return {
    ...baseIconConfig,
    url: noteIcon,
  };
}

/**
 * Get user location marker icon
 * @returns {Object} - Google Maps marker icon configuration
 */
export function getUserIcon() {
  const svg = `
    <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="16" fill="#4285F4" stroke="white" stroke-width="4"/>
      <circle cx="24" cy="24" r="6" fill="white"/>
    </svg>
  `;

  return {
    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
    scaledSize: new window.google.maps.Size(48, 48),
    anchor: new window.google.maps.Point(24, 24),
  };
}
